module.exports = __webpack_public_path__ + "static/media/stakeholders_mobile.13407010.jpg";